import React, { Component } from 'react';
import Layout from './Components/DeafultLayout/Layout/layout'
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Login  from './Views/Pages/Login/Login';
import ForgetPassword from './Views/Pages/forgetPasswordView/forgetPassword/forgetPassword'
import SendEmail from './Views/Pages/forgetPasswordView/Email/email'
import ConfirmationCode from './Views/Pages/forgetPasswordView/confirmationCode/confirmationCode'
import ResetPassword from './Views/Pages/forgetPasswordView/resetPassword/resetPassword'

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/Maktapti/login" name="Login Page" component={Login} />
          <Route exact path="/Maktapti/email" name="Reset Password " component={SendEmail} />
          <Route exact path="/Maktapti/confirmcode" name="Reset Password Code" component={ConfirmationCode} />
          <Route exact path="/Maktapti/resetPassword" name="Reset Password " component={ResetPassword} />
          <Route exact path="/Maktapti/forgetPassword" name="Forget Password" component={ForgetPassword} />
          <Route path="/Maktapti" name="Home" component={Layout} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default (App);
